<template>
    <div class="vacancy-detail">
        <slot name="title">
            <z-caption
                tag="h2"
                size="lt"
                class="u-bottom-margin--3xs-important"
            >
                {{ detail.item.name }}
            </z-caption>
        </slot>
        <div class="text-size-m u-bottom-margin--xs">{{ detail.item.location.value }}</div>
        <div class="vacancy-detail__info">
            <div class="vacancy-detail__info-row">
                <div v-if="detail.item.hot.value === 'Y'" class="col-default-1 col-v-tablet-12">
                    <z-icon
                        name="icon/fire"
                        width="64"
                        height="64"
                    />
                </div>
                <div class="col-default-3 col-v-tablet-12">
                    <div class="vacancy-detail__info-label">Организация</div>
                    <div class="vacancy-detail__info-value">
                        {{ detail.item.organization[0].name }}
                    </div>
                </div>
                <div v-if="detail.item.experience.value" class="col-default-3 col-v-tablet-12">
                    <div class="vacancy-detail__info-label">Опыт работы</div>
                    <div class="vacancy-detail__info-value">{{ detail.item.experience.value }}</div>
                </div>
                <div v-if="detail.item.type.value" class="col-default-3 col-v-tablet-12">
                    <div class="vacancy-detail__info-label">Тип вакансии</div>
                    <div class="vacancy-detail__info-value">
                        {{ detail.item.type.value }}
                        <span v-if="detail.item.education.value == 'Y'"><br>Возможно обучение</span>
                    </div>
                </div>
                <div v-if="detail.item.schedule.value" class="col-default-2 col-v-tablet-12">
                    <div class="vacancy-detail__info-label">График работы</div>
                    <div class="vacancy-detail__info-value">{{ detail.item.schedule.value }}</div>
                </div>
            </div>
        </div> 
        <z-button
            tag="a"
            :href="`/career/send-cv?vacancy-id=${detail.item.code}&name=${detail.item.name}`+ (detail.item.hot.value === 'Y' ? '&hot=Y' : '')"
            class="vacancy-detail__button"
            kind="primary"
            :size="isMobile ? 's' : 'm'"
        >
            Откликнуться на вакансию
        </z-button>
        <div v-if="detail.item.additional.value" class="vacancy-detail__content">
            <h3 class="vacancy-detail__content-title">Преимущество вакансии</h3>
            <div class="vacancy-detail__content-text html-content" v-html="detail.item.additional.value" />
        </div>
        <div class="vacancy-detail__content">
            <z-link href="/career/corporate-life/care/" internal><span class="text-size-l">Забота о сотрудниках</span></z-link>
        </div>
        <div v-if="detail.item.activity.value" class="vacancy-detail__content">
            <h3 class="vacancy-detail__content-title">Чем вы будете заниматься</h3>
            <div class="vacancy-detail__content-text html-content" v-html="detail.item.activity.value" />
        </div>
        <div v-if="detail.item.quality.value" class="vacancy-detail__content">
            <h3 class="vacancy-detail__content-title">Нам важно, чтобы у вас было</h3>
            <div class="vacancy-detail__content-text html-content" v-html="detail.item.quality.value" />
        </div>
        <div v-if="detail.item.description" class="vacancy-detail__content">
            <h3 class="vacancy-detail__content-title">Что мы предоставляем</h3>
            <div class="vacancy-detail__content-text html-content" v-html="detail.item.description" />
        </div>

        <div class="vacancy-detail__bottom">

        </div>
        
        <z-button
            tag="a"
            :href="`/career/send-cv?vacancy-id=${detail.item.code}&name=${detail.item.name}`+ (detail.item.hot.value === 'Y' ? '&hot=Y' : '')"
            class="vacancy-detail__button"
            kind="primary"
            :size="isMobile ? 's' : 'm'"
        >
            Откликнуться на вакансию
        </z-button>

        <z-page-nav :data="detail.nav" button-text="Вернуться к списку" class="u-mt-m"></z-page-nav>
    </div>
</template>

<script setup>
import {computed} from 'vue';
import { useStore } from 'vuex';
import { useGetter } from '@/composable/useGetter'
import { localize } from '@/utils/i18n'

const { app } = useGetter(['app'])
const {device} = useGetter(['device'])
const detail = app.value.components['vacancies-detail']
const pageTitle = localize({
    ru: 'Вакансии для твоей карьеры',
    en: 'Вакансии для твоей карьеры',
    cn: 'Вакансии для твоей карьеры'
})
const store = useStore();

const isMobile = computed(() => device.value === 'mobile')

const setTitle = (title) => {
    store.dispatch('SetHeroTitle', title);
    store.dispatch('SetHeroTitleTag', 'h2');
};

setTitle(pageTitle);

</script>

<style lang="scss" scoped>
.vacancy-detail{
    &__back{
        @include margin-level(bottom, XS);
        display: block;
    }

    &__info{
        @include margin-level(bottom, L);
    }
    &__info-row{
        padding: 24px;
        display: flex;
        flex-wrap: wrap;
        background: var(--color-black-5);
        border-radius: 24px;

        @include breakpoint(v-tablet){
            gap: 20px;
        }

        @include breakpoint(mobile){
            padding: 16px;
        }
    }

    &__info-label{
        margin-bottom: 4px;
        @include typo-level(S);
        color: var(--color-table-text-middle)
    }

    &__info-value{
        font-size: var(--typography-m);
        // @include typo-level(M);
    }

    &__button {
        margin-bottom: var(--spacer-l);
    }

    &__content{
        @include margin-level(bottom, L);
    }
    &__content-title{
        @include margin-level(bottom, XS);
        font-size: var(--typography-xl);
        // @include typo-level(3XL);
    }

    &__content-text{
        @include typo-level(m);
    }
}
</style>
